import moment from "moment";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { surgeTypes } from "../../reducers/recuperos/surgeTypes";

export const setEstadoBandejaImagenes = (estado) => {
    return {
        type: surgeTypes.getEstadosCargaImagenesSolicitudes,
        payload: estado,
    };
};

export const traerSolicitudesAltoCosto =
    (fechaInicio, fechaFin, idAfiliado = 0, idProblema = 0, setContadorBandeja, setRadioGroupDisabled) => async (dispatch) => {
        let fechaDesde = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
        let fechaHasta = fechaFin instanceof Date ? moment(fechaFin).format() : '';
        try {
            setRadioGroupDisabled && setRadioGroupDisabled(true);
            const response = await fetchConToken(
                `Surge/SolAltoCostoSurge/${fechaDesde}/${fechaHasta}/${idAfiliado}/${idProblema}`,
            );
            const body = await response.json();

            if (response.ok) {
                dispatch({
                    type: surgeTypes.getSolicitudesBandejaImagenesSurge,
                    payload: body,
                });
                const totalSolicitudes = body?.length;
                setContadorBandeja && setContadorBandeja(totalSolicitudes)
                setRadioGroupDisabled && setRadioGroupDisabled(false);
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(
                dispatch,
                error,
                'Error al cargar la informacion.',
                'Ha ocurrido un error. Intente Nuevamente',
            );
        }
    };

export const traerSolicitudesMaterialesSurge =
    (fechaInicio, fechaFin, idAfiliado = 0, idProblema = 0, setContadorBandeja, setRadioGroupDisabled) => async (dispatch) => {
        let fechaDesde = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
        let fechaHasta = fechaFin instanceof Date ? moment(fechaFin).format() : '';
        try {
            setRadioGroupDisabled && setRadioGroupDisabled(true);
            const response = await fetchConToken(
                `Surge/SolMaterialesSurge/${fechaDesde}/${fechaHasta}/${idAfiliado}/${idProblema}`,
            );
            const body = await response.json();

            if (response.ok) {
                dispatch({
                    type: surgeTypes.getSolicitudesBandejaImagenesSurge,
                    payload: body,
                });
                const totalSolicitudes = body?.length;
                setContadorBandeja && setContadorBandeja(totalSolicitudes)
                setRadioGroupDisabled && setRadioGroupDisabled(false);
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(
                dispatch,
                error,
                'Error al cargar la informacion.',
                'Ha ocurrido un error. Intente Nuevamente',
            );
        }
    };

export const traerSolicitudesConIdentificacionSurge =
    (fechaInicio, fechaFin, idAfiliado = 0, idProblema = 0, setContadorBandeja, setRadioGroupDisabled) => async (dispatch) => {
        let fechaDesde = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
        let fechaHasta = fechaFin instanceof Date ? moment(fechaFin).format() : '';
        try {
            setRadioGroupDisabled && setRadioGroupDisabled(true);
            const response = await fetchConToken(
                `Surge/SolIdenfificacionSurge/${fechaDesde}/${fechaHasta}/${idAfiliado}/${idProblema}`,
            );
            const body = await response.json();

            if (response.ok) {
                dispatch({
                    type: surgeTypes.getSolicitudesBandejaImagenesSurge,
                    payload: body,
                });
                const totalSolicitudes = body?.length;
                setContadorBandeja && setContadorBandeja(totalSolicitudes)
                setRadioGroupDisabled && setRadioGroupDisabled(false);
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(
                dispatch,
                error,
                'Error al cargar la informacion.',
                'Ha ocurrido un error. Intente Nuevamente',
            );
        }
    };

export const traerSolicitudPagoSurge =
    (fechaInicio, fechaFin, idAfiliado = 0, idProblema = 0, setContadorBandeja, setRadioGroupDisabled) => async (dispatch) => {
        let fechaDesde = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
        let fechaHasta = fechaFin instanceof Date ? moment(fechaFin).format() : '';
        try {
            setRadioGroupDisabled && setRadioGroupDisabled(true);
            const response = await fetchConToken(
                `Surge/SolPagoSurge/${fechaDesde}/${fechaHasta}/${idAfiliado}/${idProblema}`,
            );
            const body = await response.json();

            if (response.ok) {
                dispatch({
                    type: surgeTypes.getSolicitudesBandejaImagenesSurge,
                    payload: body,
                });
                const totalSolicitudes = body?.length;
                setContadorBandeja && setContadorBandeja(totalSolicitudes)
                setRadioGroupDisabled && setRadioGroupDisabled(false);
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(
                dispatch,
                error,
                'Error al cargar la informacion.',
                'Ha ocurrido un error. Intente Nuevamente',
            );
        }
    };

export const traerSolicitudPagoConOPSurge =
    (fechaInicio, fechaFin, idAfiliado = 0, idProblema = 0, setContadorBandeja, setRadioGroupDisabled) => async (dispatch) => {
        let fechaDesde = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
        let fechaHasta = fechaFin instanceof Date ? moment(fechaFin).format() : '';
        try {
            setRadioGroupDisabled && setRadioGroupDisabled(true);
            const response = await fetchConToken(
                `Surge/SolPagoConOpSurge/${fechaDesde}/${fechaHasta}/${idAfiliado}/${idProblema}`,
            );
            const body = await response.json();

            if (response.ok) {
                dispatch({
                    type: surgeTypes.getSolicitudesBandejaImagenesSurge,
                    payload: body,
                });
                const totalSolicitudes = body?.length;
                setContadorBandeja && setContadorBandeja(totalSolicitudes)
                setRadioGroupDisabled && setRadioGroupDisabled(false);
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(
                dispatch,
                error,
                'Error al cargar la informacion.',
                'Ha ocurrido un error. Intente Nuevamente',
            );
        }
    };

    export const traerSolicitudesHiv =
    (fechaInicio, fechaFin, idAfiliado = 0, idProblema = 0, setContadorBandeja, setRadioGroupDisabled) => async (dispatch) => {
        let fechaDesde = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
        let fechaHasta = fechaFin instanceof Date ? moment(fechaFin).format() : '';
        try {
            setRadioGroupDisabled && setRadioGroupDisabled(true);
            const response = await fetchConToken(
                `Surge/Hiv/${fechaDesde}/${fechaHasta}/${idAfiliado}/${idProblema}`,
            );
            const body = await response.json();

            if (response.ok) {
                dispatch({
                    type: surgeTypes.getSolicitudesBandejaImagenesSurge,
                    payload: body,
                });
                const totalSolicitudes = body?.length;
                setContadorBandeja && setContadorBandeja(totalSolicitudes)
                setRadioGroupDisabled && setRadioGroupDisabled(false);
            } else {
                throw body;
            }
        } catch (error) {
            handleErrorApi(
                dispatch,
                error,
                'Error al cargar la informacion.',
                'Ha ocurrido un error. Intente Nuevamente',
            );
        }
    };